import { render, staticRenderFns } from "./EntityButton.vue?vue&type=template&id=33f9c5aa&scoped=true&"
import script from "./EntityButton.vue?vue&type=script&lang=js&"
export * from "./EntityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9c5aa",
  null
  
)

export default component.exports